import { Col, Icon, Row, Select } from '@advanza/advanza_generic'
import React from 'react'
import StatusesFilterContainer from '../../containers/StatusesFilterContainer'
import Pagination from '../Pagination'
import SafeButton from '../ui/SafeButton'

class StatusesFilter extends React.Component {
    constructor(props) {
        super(props)
        this.onPageChange = this.onPageChange.bind(this)
        this._changeFilter = this._changeFilter.bind(this)
        this.add = this.add.bind(this)
        this.onCategoryChange = this.onCategoryChange.bind(this)
        this.deleteSelection = this.deleteSelection.bind(this)
    }

    _changeFilter(options) {
        const { changeFilter, filterId } = this.props
        changeFilter(filterId, options)
    }

    componentDidMount() {
        const { defaultOptions = {}, filter } = this.props
        if (!filter) {
            this._changeFilter(defaultOptions)
        }
    }

    componentDidUpdate(prevProps) {
        const prevFilter = prevProps.filter || {}
        const { filter = {} } = this.props
        const didInvalidate = !prevFilter.didInvalidate && filter.didInvalidate
        if (didInvalidate) {
            // Because the filter is invalidated changing it will refetch the items.
            this._changeFilter({})
        }
    }

    onPageChange(page, invalidate = false) {
        this._changeFilter({ page, didInvalidate: invalidate })
    }

    onCategoryChange(e) {
        const { value: category } = e.target
        this._changeFilter({ categories: [category] })
    }

    add() {
        const { add, filter } = this.props
        add(
            {
                category:
                    filter.categories && filter.categories.length > 0 ? filter.categories[0] : '',
            },
            filter.filterId,
        )
    }

    deleteSelection() {
        const { filter, deleteSelection } = this.props
        return deleteSelection(filter.filterId)
    }

    render() {
        const { filter, count, compact, categories } = this.props

        if (!filter || compact) {
            return null
        }

        const pageNr = filter.page || 0
        const selection = filter.selection
        return (
            <Row className="v-center" nm>
                <Col c="auto" np>
                    <Select
                        onChange={this.onCategoryChange}
                        placeholder="All categories"
                        className="select-stealth select-min upper c-blue"
                        value={filter.categories || ''}
                        options={categories.map((category) => {
                            return {
                                value: category,
                                title: category,
                            }
                        })}
                    />
                </Col>
                {selection && selection.length > 0 && (
                    <SafeButton
                        action={this.deleteSelection}
                        className="btn warning"
                        confirmMessage={`delete ${selection.length} labels`}
                        buttonText="delete"
                    />
                )}
                <div className="to-right">
                    <button onClick={this.add} className="plain c-blue">
                        <Icon>add</Icon> add
                    </button>
                    {count > filter.pageSize && (
                        <Pagination
                            current={pageNr}
                            pageSize={filter.pageSize}
                            count={count}
                            onPageChange={this.onPageChange}
                        />
                    )}
                </div>
            </Row>
        )
    }
}

export default StatusesFilterContainer(StatusesFilter)
